import { useThemeWithoutDefault } from '@mui/system';
import { defaultTheme } from './default-theme';
export var useTheme = function () { return useThemeWithoutDefault(defaultTheme); };
